var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      directives: [
        {
          name: "analytics",
          rawName: "v-analytics",
          value: { label: "special_icon_click" },
          expression: "{label:'special_icon_click'}",
        },
      ],
      staticClass: "global-navi-beautyday-button-term3",
      attrs: { href: _vm.link },
    },
    [_vm._v("アットコスメビューティーデー開催中！")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }